<template>
  <div data-component-group="thread-panels" data-component="account-owner">
    <div class="contact-box">
      <v-icon>account_circle</v-icon>

      <router-link class="owner-name" :to="{ name: 'internal-users-edit', params: { id: owner.id } }" target="_blank">
        {{ ownerName }}
      </router-link>
    </div>
  </div>
</template>

<script>
  import { isObj, isStr } from '../../../utils';

  export default {
    props: {
      owner: {
        type: Object,
        required: true,
        validator(value) {
          return isObj(value) && isStr(value.firstname) && isStr(value.lastname);
        },
      },
    },
    computed: {
      ownerName() {
        const { firstname, lastname } = this.owner;
        return `${firstname} ${lastname}`;
      },
    },
  };
</script>

<style lang="scss">
@use '../../../assets/styles/theme' as *;

[data-component-group='thread-panels'] {
  &[data-component='account-owner'] {
    .contact-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 0 0 -2px;

      .v-icon {
        font-size: $text-size-lg + 0.125rem;
        margin: 0 4px 0 0;
      }

      .owner-name {
        font-weight: bold;
      }
    }
  }
}
</style>
